module.exports = __webpack_public_path__ + "static/media/dma_1.ac5b87ed.svg";